import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import ControlTaskForm from '../../../components/forms/ControlTaskForm'
import Popup from '../../../components/elements/Popup'

import Types from '../../../actions/Types'
import PostAction from '../../../actions/controlTasks/PostAction'
import ListUsersAction from '../../../actions/users/ListAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class CreateControlTaskPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      submit: null
    }

    // Bind events
    this.submit = this.submit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    this.props.fetchUsers()
  }

  componentDidUpdate(prevProps, prevState) {
    // When successful, close popup
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.error
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Tâche créée.')
      this.props.onClose(true)
    }
  }

  submit() {
    if (_.isFunction(this.state.submit)) {
      this.state.submit()
    }
  }

  onSubmit(data) {
    this.props.post(_.extend(
      {
        control: {
          id: this.props.controlId
        }
      },
      data
    ))
  }

  render() {
    return (
      <Popup
        header='Ajouter une tâche'
        body={
          <ControlTaskForm
            data={undefined}
            onSubmit={this.onSubmit}
            onClearError={this.props.clearError}
            isLoading={false}
            isSaving={this.props.isSaving}
            registerSubmit={(submit) => { this.setState({ submit })}}
            error={this.props.error}
            usersList={this.props.usersList}
            usersIsFetching={this.props.usersIsFetching}
          />
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Annuler',
            color: 'red',
            icon: 'close',
            basic: true,
            onClick: () => this.props.onClose(false)
          },
          {
            type: Popup.BUTTONTYPE.SUBMIT,
            title: 'Créer',
            color: 'green',
            icon: 'checkmark',
            onClick: this.submit
          }
        ]}
        isSaving={this.props.isSaving}
      />
    )
  }
}

CreateControlTaskPopup.propTypes = {
  // Properties
  controlId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,

  // Redux State
  isSaving: PropTypes.bool.isRequired,
  error: PropTypes.object,
  usersList: PropTypes.array,
  usersIsFetching: PropTypes.bool.isRequired,

  // Redux Actions
  post: PropTypes.func.isRequired,
  fetchUsers: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    isSaving: state.entities.controls.task.post.isFetching,
    error: state.entities.controls.task.post.error,
    usersList: state.entities.users.list.data,
    usersIsFetching: state.entities.users.list.isFetching
  }),
  (dispatch) => ({
    post: (data) => (dispatch(PostAction({ data }))),
    fetchUsers: () => (dispatch(ListUsersAction({}))),
    clearError: () => (dispatch(ClearErrorAction(Types.CTRL_TASKS.POST)))
  })
)(CreateControlTaskPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/controlTasks/CreateControlTaskPopup.js